import { Button, Result } from 'antd';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';

export interface INotFoundProps {}

export default function NotFound() {
  const navigate = useNavigate();
  const backToHome = () => {
    navigate('/');
  };
  return (
    <Result
      status="404"
      title="404"
      subTitle="Sorry, the page you visited does not exist."
      extra={
        <Button type="primary" onClick={backToHome}>
          Back Home
        </Button>
      }
    />
  );
}
